import HttpRequest from "@/plugins/http";

const request = new HttpRequest({
  baseURL: "/hotel/booking/v1",
});

const axios = request.request();

/**
 * BookingPayment
 * @export
 * @param {Object} params -
 * @param {number} [params.amount] -
 * @param {string} [params.currencyCode] -
 * @returns
 */
export async function bookingPayment(params) {
  return axios.get("/bookpayment/bookingPayment", params);
}

/**
 * HotelOrder - Create Booking Hotel Order
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function createBooking(params) {
  return axios.post("/orders/create", params);
}

/**
 * HotelOrder - Cancel Booking Hotel Order
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function cancelBooking(params) {
  return axios.post("/orders/cancel", params);
}
/**
 * HotelOrder - Cancel Booking Hotel Order
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function cancelPendingBooking(params) {
  return axios.post("/orders/cancelPendingBooking", params);
}

/**
 * HotelOrder - get booking hotel order list
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function getBookingList(params) {
  return axios.post("/orders/list", params);
}
export async function BookingDelete(params) {
  return axios.get("/orders/delete", params);
}

/**
 * HotelOrder -
 * @export
 * @param {Object} params -
 * @param {string} [params.bookingId] -
 * @param {boolean} [params.returnDescriptiveInfo] -
 * @returns
 */
export async function bookingDetail(params) {
  return axios.get("/orders/details", params);
}

/**
 * HotelOrder - bookings property rate
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function bookingsPropertyRate(params) {
  return axios.post("/orders/property/rate", params);
}

/**
 * HotelOrder - bookings property rate
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function bookingBreakfastCheck(params) {
  return axios.post("/orders/property/BreakfastCheck", params);
}

/**
 * HotelOrder - bookings update
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function bookingsUpdate(params) {
  return axios.post("/orders/update", params);
}

/**
 * HotelOrder - get big order  list
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function getBigOrderList(params) {
  return axios.post("/orders/bigOrderList", params);
}

/**
 * HotelOrder -  big order  update
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function updateBigOrder(params) {
  return axios.post("/orders/bigOrderUpdate", params);
}

/**
 * HotelOrder -  big order  Create
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function createeBigOrder(params) {
  return axios.post("/orders/bigOrderCreate", params);
}

/**
 * HotelOrder - bookings down
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function bookingsDownLoadExcel(params) {
  return axios.post("/orders/downLoadExcel", params, {
    responseType: "blob",
  });
}

/**
 * HotelOrder - bookings down
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function bookingsPreDownLoadExcel(params) {
  return axios.post("/orders/preDownLoadExcel", params);
}

/**
 * HotelOrder - Check OrderCreator
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function CheckOrderCreator(params) {
  return axios.post("/orders/checkOrderCreator", params);
}

/**
 * HotelOrder - get OperationLog
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function getOperationLog(params) {
  return axios.get("/orders/getOperationLog", params);
}


/**
 * HotelOrder - verifyrepeat
 * @export
 * @param {JSON} params - 验证是否重复订单
 * @returns
 */
export async function verifyRepeatOrder(params) {
  return axios.post("/orders/verifyrepeat", params);
}

/**
 * HotelOrder - remark
 * @export
 * @param {JSON} params - 查询CRM人员备注信息
 * @returns
 */
export async function getRemarkInfo(params) {
  return axios.get("/orders/remark", params);
}

/**
 * HotelOrder - remark
 * @export
 * @param {JSON} params - 添加CRM备注信息
 * @returns
 */
export async function createRemarkInfo(params) {
  return axios.post("/orders/remark", params);
}

/**
 * HotelOrder - remark
 * @export
 * @param {JSON} params - 修改服务费信息
 * @returns
 */
export async function updateServiceCharge(params) {
  return axios.post("/orders/updateServiceCharge", params);
}

/**
 * HotelOrder - remark
 * @export
 * @param {JSON} params - 修改服务费信息并支付
 * @returns
 */
export async function updateServiceChargeToPay(params) {
  return axios.post("/orders/updateServiceChargeToPay", params);
}

/**
 * 查询行程单
 * @export
 * @param {Object} params -
 * @returns
 */
export async function repeatItinerary(params) {
  return axios.post("/orders/repeatItinerary", params);
}

/**
 * HotelOrder - verifyrepeat
 * @export
 * @param {JSON} params - 验证是否重复订单
 * @returns
 */
export async function elongPay(params) {
  return axios.post("/orders/elongPayDecrypt", params);
}

/**
 * HotelOrder - verifyrepeat
 * @export
 * @param {JSON} params - 验证是否重复订单
 * @returns
 */
export async function elongPayConfirm(params) {
  return axios.post("/orders/elongPayConfirm", params);
}

/**
 * 获取行程单预览
 * @export
 * @param {Object} params
 * @returns
 */
export async function getPreviewItinerary(params) {
  return axios.get("/orders/previewItinerary", params);
}

/**
 * 获取热门城市
 * @export
 * @param {Object} params
 * @returns
 */
export async function gethothotel(params) {
  return axios.get("/orders/gethothotel", params);
}

/**
 * 获取consul Value
 */
export async function getConsul(params) {
  return axios.get("/orders/getConsul", params);
}

/**
 * name转为拼音
 */
export async function toPinyin(params) {
  return axios.get("/util/topinyin", params);
}

/**
 * 修改成本中心
 */
export async function costcenterupdate(params) {
  return axios.post("/orders/costcenterupdate", params);
}

/**
 * 拒绝取消订单
 */
export async function refuseBooking(params) {
  return axios.post("/orders/refuseorder", params);
}

/**
 * 手动同步pnr和酒店确认单号
 */
export async function updatePnrAndConfirmationNo(params) {
  return axios.get("/orders/updatePnrAndConfirmationNo", params);
}

/**
 * 获取待补单列表
 */
export async function getManualOrderList(params) {
  return axios.get("/manualOrder/list", params);
}

/**
 * 保存、删除待补单
 */
export async function saveManual(params) {
  return axios.post("/manualOrder/save", params);
}

/**
 * 获取支付二维码
 */
export async function hoteltradePay(params) {
  return axios.post("/hoteltrade/KQPay", params);
}

/**
 * 查询交易状态
 */
export async function hoteltradeQuery(params) {
  return axios.post("/hoteltrade/Query", params);
}

/**
 * 退款
 */
export async function hoteltradeRefund(params) {
  return axios.post("/hoteltrade/Refund", params);
}

/**
 * 获取退款列表
 */
export async function getrefundlist(params) {
  return axios.post("/hoteltrade/getrefundlist", params);
}

/**
 * 保存退款申请
 */
export async function hoteltradeSaveRefund(params) {
  return axios.post("/hoteltrade/saverefund", params);
}

/**
 * 计算退款金额
 */
export async function calculateRefundAmount(params) {
  return axios.post("/orders/calculateRefundAmount", params);
}

/**
 * 申请被拒
 */
export async function hoteltradeRefusedrefund(params) {
  return axios.get("/hoteltrade/refusedrefund", params);
}

/**
 * 同意退款
 */
export async function hoteltradeAgreerefund(params) {
  return axios.get("/hoteltrade/agreerefund", params);
}

/**
 * 获取发票联系人列表
 */
export async function getInvoiceContactList(params) {
  return axios.get("/invoice/getInvoiceContactList", params);
}

/**
 * 更新发票联系人
 */
export async function saveInvoiceContact(params) {
  return axios.post("/invoice/saveInvoiceContact", params);
}

/**
 * 快钱支付签约
 */
export async function getContract(params) {
  return axios.post("/hoteltrade/contractSmsToken", params);
}

/**
 * 获取Incident列表信息
 */
export async function getIncidentList(params) {
  return axios.post("/orders/incidentList", params);
}

/**
 * Incident - downLoad
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function incidentpreDownLoadExcel(params) {
  return axios.post("/orders/preDownloadIncidentExcel", params);
}

/**
 * HotelOrder - bookings down
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function incidentDownLoadExcel(params) {
  return axios.post("/orders/downloadIncidentExcel", params, {
    responseType: "blob",
  });
}

/**
 * HotelOrder - bookings update
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function confirmUpdate(params) {
  return axios.post("/orders/confirmUpdate", params);
}

/**
 * HotelOrder - bookings confirmCompletion
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function confirmCompletion(params) {
  return axios.post("/orders/confirmCompletion", params);
}

/**
 * HotelOrder - bookings confirmCompletion
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function saveInvoice(params) {
  return axios.post("/invoice/saveInvoiceRecoed", params);
}

/**
 * HotelOrder - bookings updateRoomtypeAndBreakfast
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function updateApprovedData(params) {
  return axios.post("/orders/updateRoomtypeAndBreakfast", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function searchInvoiceConfig(params) {
  return axios.get("/invoice/searchConfig", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function saveInvoiceConfig(params) {
  return axios.post("/invoice/saveConfig", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function searchInvoiceList(params) {
  return axios.post("/invoice/searchList", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function preDownloadInvocieExcel(params) {
  return axios.post("/invoice/preDownloadInvocieExcel", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function downloadInvocieExcel(params) {
  return axios.post("/invoice/downloadInvocieExcel", params, {
    responseType: "blob",
  });
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function getInvoiceRecoed(params) {
  return axios.get("/invoice/getInvoiceRecoed", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function repeatInvoiceEmail(params) {
  return axios.post("/invoice/repeatSendInvoiceEmail", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function getOrderStatus(params) {
  return axios.get("/orders/orderStatus", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function updateInvoiceRecordStatus(params) {
  return axios.get("/invoice/updateInvoiceRecordStatus", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function getHotelOrderInfo(params) {
  return axios.get("/orders/getManualOrderInfo", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function getOrderWaitiMonitor(params) {
  return axios.get("/orders/getOrderWaitiMonitor", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function getChannelFailures(params) {
  return axios.get("/orders/getChannelFailures", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function selectManualOrder(params) {
  return axios.post("/manualOrder/selectManualOrder", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function getElongUserAgreement(params) {
  return axios.get("/orders/getElongUser_Agreement", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function getIsAgreeAgreement(params) {
  return axios.get("/orders/getIsAgreeAgreement", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function getInvoiceErrorMessage(params) {
  return axios.get("/invoice/getInvoiceErrorMessage", params);
}